import { ExternalLink, Icon } from '@ui/themed';
import type { ReactNode } from 'react';
import type { IconName } from '../../../components/ui/icon/types';

export function SectionTitle({
  icon = 'infoCircle',
  href,
  children,
}: {
  icon?: IconName;
  href: string;
  children: ReactNode;
}) {
  return (
    <div className="flex items-center gap-1">
      <Icon name={icon} size="md" />
      <ExternalLink link={href}>{children}</ExternalLink>
    </div>
  );
}
